import { render, staticRenderFns } from "./PromoDropdownV2.vue?vue&type=template&id=ec28907e&scoped=true"
import script from "./PromoDropdownV2.vue?vue&type=script&lang=js"
export * from "./PromoDropdownV2.vue?vue&type=script&lang=js"
import style0 from "./PromoDropdownV2.vue?vue&type=style&index=0&id=ec28907e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec28907e",
  null
  
)

export default component.exports